import OT from '@opentok/client';

// const MOST_RECENT_VIDEO_KEY = 'MOST_RECENT_VIDEO_KEY';
// const MOST_RECENT_AUDIO_KEY = 'MOST_RECENT_AUDIO_KEY';

class OTVideController {
  // currentVideoDevice: OT.Device | null = null;

  static getDevices = (): Promise<OT.Device[]> => {
    return new Promise((resolve, reject) => {
      OT.getDevices((err, devices) => {
        if (err) {
          reject(err);
          return;
        }
        resolve((devices || []).filter((d) => d.kind === 'videoInput' || d.kind === 'audioInput'));
        // resolve({
        //   videoDevices: (devices || []).filter(d => d.kind === 'videoInput'),
        //   audioDevices: (devices || []).filter(d => d.kind === 'audioInput'),
        // });
      });
    });
  };

  public static isValidDevice = async (
    deviceId: string | null | undefined,
    kind: OT.Device['kind']
  ): Promise<boolean> => {
    if (!deviceId) {
      return false;
    }
    const devices = await OTVideController.getDevices();
    return !!devices.find((d) => d.deviceId === deviceId && d.kind === kind);
  };
}

export default OTVideController;
